<template>

  <!-- <el-menu-item :index="menu.path || uniqueId"  v-if="auths.includes(menu.auth_token)||menu.auth_token=='header'"> -->
  <el-menu-item :index="menu.path || uniqueId">
    <!-- <i v-if="menu.icon" :class="`fa fa-${menu.icon}`"></i> -->
    <i v-if="menu.icon" :class="`iconfont ${menu.icon}`"></i>
    <!-- <i v-if="menu.icon === undefined & !menu.iconSvg" class="fa fa-file-o"></i> -->
    <d2-icon-svg v-if="menu.iconSvg" :name="menu.iconSvg"/>
    <span slot="title">{{menu.title || '未命名菜单'}} </span>
  </el-menu-item>
</template>

<script>
import { uniqueId } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'd2-layout-header-aside-menu-item',
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...mapState('d2admin/menu', [
      'aside',
      'asideCollapse',
      'auths'
    ])
  },
  data () {
    return {
      uniqueId: uniqueId('d2-menu-empty-')
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/no-header/components/components/menu-item/index.vue"
}
</vue-filename-injector>
